import React from "react";

import { underwritingDetailPagePermissionSet } from "helpers";
import { getUnderwritingAppLink } from "mappers";
import { useUnderwritingSearchQuery } from "queries";

import { underwritingResultItem } from "../resultItems";

import UnderwritingIcon from "static/images/underwriting2.png";

const underwritingSection = () => {
	return {
		name: "underwriting",
		title: "Underwriting",
		useSearchQuery: useUnderwritingSearchQuery,
		renderItem: underwritingResultItem,
		getIcon: () => <img src={UnderwritingIcon} alt="" />,
		getLink: ({ id, application_status }) => {
			return getUnderwritingAppLink(application_status, id);
		},
		requiredPermissions: underwritingDetailPagePermissionSet,
	};
};

export default underwritingSection;
